/**
 * Rules of the "File shares (optional)" field (plan §3.2): when it shows, and how its text becomes the entry list.
 * Kept apart from the component so it exports components only (fast refresh).
 */
import type { ConnectionFormValues } from './connectionFormSchema';
import { storageShowsDataAccess } from './AzureStorageDataAccessFields';

/** Comma / newline separated → trimmed, non-empty entries in order (duplicates kept for the problem list). */
export function namedSharesFromText(text: string): string[] {
  return text.split(/[,\n]/u).map((entry) => entry.trim()).filter((entry) => entry !== '');
}

/** Entra sign-in at account scope with File ticked. */
export function storageShowsNamedShares(values: Partial<ConnectionFormValues>, accountMode: boolean, fileEnabled: boolean): boolean {
  return fileEnabled && storageShowsDataAccess(values, accountMode);
}
